<template>
  <div class="homap">
    <!-- 地图载体 -->
    <div id="container"></div>
    <div id="sousuo">
      <div id="myPageTop">
        <table style="width: 100%">
          <tr>
            <td></td>
          </tr>
          <tr>
            <td>
              <el-input
                size="mini"
                v-model="input"
                placeholder="请输入关键字"
                id="tipinput"
              ></el-input>
            </td>
            <td>
              <el-button
                @click="searchAddress"
                size="mini"
                type="primary"
                plain
                id="tipbut"
                >搜索</el-button
              >
            </td>
          </tr>
        </table>
      </div>
      <div id="panel"></div>
    </div>
  </div>
</template>
<script >
let MapKey = "92bf1b30d5d094e6a625fd046e52f2db";
import remoteLoad from "@/components/map/lib/remoteLoad.js";
var placeSearch;
export default {
  naem: "Hotelmpa",
  props: ["mapCenter", "areaData"],
  data() {
    return {
      sum: "",
      map: "",
      marker: "",
      geocoder: "",
      // 坐标
      lnglat: "",
      // 地址
      address: "",
      lng: "",
      lat: "",
      input: "",
    };
  },
  async created() {
    // 已载入高德地图API，则直接初始化地图
    // 载入高德地图和UI组件
    Promise.all([
      remoteLoad(`http://webapi.amap.com/maps?v=1.3&key=${MapKey}`),
      remoteLoad("http://webapi.amap.com/ui/1.0/main.js"),
      remoteLoad(
        "https://a.amap.com/jsapi_demos/static/demo-center/js/demoutils.js"
      ),
    ]).then(() => {
      this.initMap();
    });
  },
  mounted() {},
  methods: {
    initMap() {
      let that = this;
      var map = new AMap.Map("container", {
        resizeEnable: true,
      });
      this.map = map;
      // 启用工具条
      AMap.plugin(
        ["AMap.ToolBar", "AMap.Geocoder", "AMap.Geolocation"],
        function () {}
      );
      AMap.service(["AMap.PlaceSearch"], function () {
        //构造地点查询类
        placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: String(that.areaData), // 兴趣点城市
          citylimit: true, //是否强制限制在设置的城市内搜索
          map: map, // 展现结果的地图实例
          panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: false, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          renderStyle: "default",
        });
      });
      // 添加列表点选监听事件
      AMap.event.addListener(placeSearch, "selectChanged", this.selectAddress);
      var geocoder = new AMap.Geocoder({
        map: map,
        radius: 1000, //范围，默认：500
      });
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 10000, //超过10秒后停止定位，默认：无穷大
        maximumAge: 0, //定位结果缓存0毫秒，默认：0
        convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
        showButton: true, //显示定位按钮，默认：true
        buttonPosition: "LB", //定位按钮停靠位置，默认：'LB'，左下角
        buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        showMarker: false, //定位成功后在定位到的位置显示点标记，默认：true
        showCircle: false, //定位成功后用圆圈表示定位精度范围，默认：true
        panToLocation: false, //定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: false, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
      });
      // 把定位插件加入地图实例
      map.addControl(geolocation);
      // 添加地图全局定位事件
      AMap.event.addListener(geolocation, "complete", (data) => {
        // 防止多点生成
        if (!this.marker) {
          let latLong = JSON.parse(localStorage.getItem("tr_tr_user"));
          if (
            that.mapCenter.length != 0 &&
            that.mapCenter[0] &&
            that.mapCenter[1]
          ) {
            that.lng = that.mapCenter[0];
            that.lat = that.mapCenter[1];
          } else if (latLong.longitude && latLong.latitude) {
            that.lng = latLong.longitude;
            that.lat = latLong.latitude;
          } else {
            that.lng = Number(data.position.getLng());
            that.lat = Number(data.position.getLat());
          }
          var marker = new AMap.Marker({
            map: map,
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
            position: [that.lng, that.lat],
            draggable: true,
          });
          this.marker = marker;
          that.showInfoM([that.lng, that.lat], 1);
          map.setFitView();
          // 重置缩放
          map.setZoom(16);
        }
      }); //返回定位信息
      // AMap.event.addListener(geolocation, "error", ); //返回定位出错信息
      // 调用定位
      geolocation.getCurrentPosition();
      this.geocoder = geocoder;
      setTimeout(() => {
        this.clickOn();
      }, 1000);
    },
    // 坐标转为地址
    showInfoM(e, data) {
      let that = this;
      if (data == 1) {
        var lnglat = e;
        this.lnglat = lnglat;
        this.geocoder.getAddress(lnglat, function (status, result) {
          if (status === "complete" && result.regeocode) {
            var address = result.regeocode.formattedAddress;
            that.address = address;
          } else {
          }
          that.choseValue();
        });
      } else {
        var lnglat = e.target.getPosition();
        this.lnglat = lnglat;
        this.geocoder.getAddress(lnglat, function (status, result) {
          if (status === "complete" && result.regeocode) {
            var address = result.regeocode.formattedAddress;
            that.address = address;
          } else {
          }
          that.choseValue();
        });
      }
    },
    choseValue(value) {
      this.$emit("selectFunc", this.lnglat, this.address);
    },
    // 启动拖拽事件
    clickOn() {
      setTimeout(() => {
        this.marker.on("dragend", this.showInfoM);
      }, 300);
    },
    // 解除拖拽事件
    clickOff() {
      this.marker.off("dragend", this.showInfoM);
    },
    // 搜索时间
    searchAddress() {
      placeSearch.search(this.input);
    },
    selectAddress(e) {
      this.map.clearMap();
      //这里获得点选地点的经纬度
      let location = e.selected.data.location;
      //   console.log("lng", location.lng);
      //   console.log("lat", location.lat);
      // Do Something
      this.marker = new AMap.Marker({
        map: this.map,
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [location.lng, location.lat],
        draggable: true,
      });
      this.showInfoM([location.lng, location.lat], 1);
      this.map.setFitView();
      this.clickOn();
    },
  },
};
</script>
<style lang="scss" scoped>
html,
body,
#container {
  height: 100%;
  width: 100%;
}
.input-card {
  position: absolute;
  left: 20px;
  top: 50px;
}
#sousuo {
  background: #fff;
  width: 300px;
  position: absolute;
  top: 180px;
  left: 30px;
  border-radius: 6px;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
  #myPageTop {
    width: 100%;
    padding: 5px 5px 0;
    #tipinput {
      width: 210px;
      height: 100%;
    }
  }
  #panel {
    max-height: 100%;
    width: 100%;
    padding: 5px;
  }
}
input:focus {
  background: #ffffff;
  border: 1px solid #2da7e0;
  /* 解决input按钮自动填充后 浏览器渲染的默认背景问题 */
  box-shadow: inset 0 0 0 1000px #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/map/Searchmap.vue